<template>
  <div>
    <el-menu :collapse="isCollapse" class="left-nav" mode="vertical" :default-active="$route.path"
             active-text-color="#409EFF" @select="handleSelect">
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
    <div id="copyRight">
      <div class="bottom" v-if="!isCollapse">
        <span class="brand">TisaIOT</span>
        <span>© 2018 Tisalabs. All rights reserved.</span>
      </div>

    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import SidebarItem from './SideBarItem.vue'
  import ScrollBar from '@/components/ScrollBar'
  import createProject from '../../../project/create-project/index'

  export default {
    name: 'SideBare',
    components: {SidebarItem, ScrollBar, createProject},
    //TODO: change this when implementing permissions and move it to authentication level verification
    created() {
      let routesarray = this.$router.options.routes;
      this.$router.options.routes.forEach(route => {

        if (route.meta.roles !== undefined && route.meta.roles.indexOf('user') > -1) {
          this.routes.push(route);

        }
      })
    },

    data: function () {
      return {
        routes: []
      }
    },
    computed: {
      ...mapGetters([
        'sidebar'
      ]),
      isCollapse() {
        return !this.sidebar.opened
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        if (key === 'create-new-project') {
          this.$store.dispatch("showModal", createProject);

          console.log(this.$store.state.app.modal.show);
        }

      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "../../../../styles/variables";

  #copyRight {
    background: $darkTransparent;
    width: 100%;
    margin-top: 1px;
    display: flex;
    flex-grow: 1;
    align-items: flex-end;

    .bottom {
      display: flex;
      align-items: start;
      flex-direction: column;
      margin-bottom: 1px;
      span {
        margin-left: 16px;
        font-size: .8em;
        display: block;

        &.brand {
          font-size: 1.8em;

        }
      }

    }
  }

  .left-nav {

  }


</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SideBare.vue